/* global Swiper */

Wee.fn.make('promotionsIndex', {
	init: function() {
		var scope = this;

		scope.$swipers = $('.swiper-promotions');

		$.screen.map([
			{
				max: 3,
				callback: function() {
					scope.destroySwipers();
					scope.initializeSwipers(2.1);
				}
			},
			{
				min: 4,
				callback: function() {
					scope.destroySwipers();
					scope.initializeSwipers(3);
				}
			}
		]);
	},

	initializeSwipers: function(slideCount) {
		var $swipers = this.$swipers;

		for (var i = 0; i < $swipers.length; i += 1) {
			Swiper($swipers[i], {
				slidesPerView: slideCount,
				spaceBetween: 10,
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				loop: true
			});
		}
	},

	destroySwipers: function() {
		var $swipers = this.$swipers;

		for (var i = 0; i < $swipers.length; i += 1) {
			var $swiper = $swipers[i];

			if ($swiper.swiper && $swiper.swiper.destroy) {
				$swiper.swiper.destroy();
			}
		}
	},

	unload: function() {
		this.destroySwipers();
	}
});
